import Router from 'vue-router';
let originPush = Router.prototype.push;
// 重写一下push方法（修复duplicated警告问题）
Router.prototype.push = function (location, resolve, reject) {
	// 如果传了resolve和rejecte就调用
	if (resolve && reject) {
		originPush.call(this, location, resolve, reject);
	} else {
		// 如果没传，我们自己传递俩函数
		originPush.call(
			this,
			location,
			() => {},
			() => {}
		);
	}
};



// WEBPACK FOOTER //
// ./src/router/patch.js